import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from 'moment';
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { pdfHeader, pdfFooter, pdfTableStyles } from "../../../../pdfUtils";
import DocumentosContenedor from "../../Revalidaciones/DocumentosContenedor";

const COMPROBANTE = [{ tipo: "comprobanteAbono", label: "Comprobante de pago", icon: "fas fa-receipt", grupo: "Abono" }];

function ListadoAbonos() {
  const { user } = useContext(AuthContext);
  const URL_ABONOS = process.env.REACT_APP_URL_ABONOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;  
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [t, i18n] = useTranslation("global");
  
  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-30);
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [formaPago, setFormaPago] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [abonoComprobante, setAbonoComprobante] = useState(null); // abono cuyo comprobante se está viendo

    
  const [idAbonoEdit, setIdAbonoEdit] = useState("");
  const [numeroEdit, setNumeroEdit] = useState("");
  const [fechaEdit, setFechaEdit] = useState("");
  const [idClienteEdit, setIdClienteEdit] = useState("");
  const [importeEdit, setImporteEdit] = useState("");
  const [importeEditViejo, setImporteEditViejo] = useState("");
  const [observacionesEdit, setObservacionesEdit] = useState("");
  const [clienteEdit, setClienteEdit] = useState("");
  const [notaEdit, setNotaEdit] = useState("");
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [validaBoton, setValidaBoton] = useState(true);
  const [text, setText] = useState(false);


  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(()=>{
    axios
      .get(`${URL_ABONOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allVentas = response.data;
        // Array para pagination
        let arrayTabla = allVentas
          .sort((a, b) => (a.idAbono < b.idAbono ? 1 : -1))
          .map((a) => {
            const cargo = a.cargosContenedor && a.cargosContenedor[0];
            return {
              _id: a._id,
              numero: a.idAbono,
              fecha: a.fecha,
              clientes: a.clientes[0].nombre_comercial,
              idClientes: a.clientes[0]._id,
              formaPago: a.formaPago,
              observaciones: a.observaciones,
              importe: a.importe,
              nota: cargo ? `Cargo ${cargo.contenedores[0].numeroReferencia}` : a.surtidos[0].contenedores[0].numeroReferencia,
              idNota: cargo ? cargo._id : a.surtidos[0]._id,
              esCargo: !!cargo,
              comprobante: a.comprobante || "No",
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);

        setComments(data);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });



  }, [ selectedFechaInicio, selectedFechaFin]);



  function PDFTabla() {
    let TotalImporte= 0
    const data = comments
    .filter(
      (comment) =>
        comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
        comment.formaPago.toLowerCase().includes(search.toLowerCase()) ||
        comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
        comment.importe.toString().includes(search) ||
        comment.numero.toString().includes(search) 
    )
    .sort((a, b) => (a.idAbono > b.idAbono ? 1 : -1))
    .map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (formaPago == 0 || formaPago == a.formaPago)
      ) {
        TotalImporte = TotalImporte + a.importe
        return [
          a.numero,
          a.fecha,
          a.clientes,
          a.formaPago,
          a.observaciones,
          "$" + new Intl.NumberFormat("en-US").format(a.importe),
        ];
      }
    });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });


    const doc = new jsPDF("landscape");
    const startY = pdfHeader(doc, "Listado de Abonos", `${selectedFechaInicio} al ${selectedFechaFin}`);
    doc.autoTable({
      ...pdfTableStyles(),
      columnStyles: { 5: { halign: "right" } },
      head: [
        [
          "Numero",
          "Fecha",
          "Cliente",
          "Forma Pago",
          "Observaciones",
          "Importe",
        ],
      ],
      body: dataPDFLimpia,
      startY,
      foot: [
        [
          "",
          "",
          "",
          "",
          "Total",
          "$" +new Intl.NumberFormat("en-US").format(TotalImporte)
        ]
      ]
    });
    pdfFooter(doc);
    doc.save(`Abonos.pdf`);
  }

  function excel() {
    const dataExcel = comments
    .filter(
      (comment) =>
        comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
        comment.formaPago.toLowerCase().includes(search.toLowerCase()) ||
        comment.importe.toString().includes(search) ||
        comment.numero.toString().includes(search) 
    )
    .sort((a, b) => (a.idAbono > b.idAbono ? 1 : -1))
    .map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (formaPago == 0 || formaPago == a.formaPago)
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Cliente: a.clientes,
          FormaPago: a.formaPago,
          Observaciones: a.observaciones,
          Importe: a.importe,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoAbonosTiendas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoAbonosTiendas",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Cliente",
          "FormaPago",
          "Observaciones",
          "Importe",
          ],
        sheetHeader: [
          "Numero",
          "Fecha",
          "Cliente",
          "FormaPago",
          "Observaciones",
          "Importe",
          ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let TotalImporte= 0
    const data = comments
    .filter(
      (comment) =>
        comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
        comment.formaPago.toLowerCase().includes(search.toLowerCase()) ||
        comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
        comment.importe.toString().includes(search) ||
        comment.numero.toString().includes(search) 
    )
    .sort((a, b) => (a.idAbono > b.idAbono ? 1 : -1))
    .map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (formaPago == 0 || formaPago == a.formaPago)
      ) {
        TotalImporte = TotalImporte + a.importe
        return [
          a.numero,
          a.fecha,
          a.clientes,
          a.formaPago,
          a.observaciones,
          "$" + new Intl.NumberFormat("en-US").format(a.importe),
        ];
      }
    });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });


    const doc = new jsPDF("landscape");
    const startY = pdfHeader(doc, "Listado de Abonos", `${selectedFechaInicio} al ${selectedFechaFin}`);
    doc.autoTable({
      ...pdfTableStyles(),
      columnStyles: { 5: { halign: "right" } },
      head: [
        [
          "Numero",
          "Fecha",
          "Cliente",
          "Forma Pago",
          "Observaciones",
          "Importe",
        ],
      ],
      body: dataPDFLimpia,
      startY,
      foot: [
        [
          "",
          "",
          "",
          "",
          "Total",
          "$" +new Intl.NumberFormat("en-US").format(TotalImporte)
        ]
      ]
    });

    pdfFooter(doc);
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Abonos",
          email: mailTo,
          fileName: "ListadoAbonos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Abonos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

 

  async function PDFOC(
    fecha,
    clientes,
    importe,
    nota,
    formaPago,
    observaciones,
    numero
  ) {

       
        const doc = new jsPDF();
        const startY = pdfHeader(doc, "Recibo de Abono", `Abono ${numero}`);
        doc.setTextColor(15, 23, 42);
        doc.setFontSize(16);
        // doc.text(`${process.env.REACT_APP_NOMBRE_INSTITUCION}`, 110, 53);
        doc.text(`___________________`, 77, 80);
        doc.text(`Firma`, 98, 90);
      
        doc.autoTable({
          ...pdfTableStyles(),
          columnStyles: { 3: { halign: "right" } },
          head: [
            [
              "Fecha",
              "Cliente",
              "Forma Pago",
              "Importe",
            ],
          ],
          body: [[
            fecha,
            clientes,
            formaPago,
            "$" + new Intl.NumberFormat("en-US").format(importe)
          ]],
          startY,

        });

        pdfFooter(doc);
        doc.save(`Abono.pdf`);

  }



  const headers = [
    { name: `${t("Numero")}`, field: "numero", sortable: true },
    { name: `${t("Fecha")}`, field: "fecha", sortable: false },
    { name: `${t("Cliente")}`, field: "clientes", sortable: true },
    { name: `${t("Forma Pago")}`, field: "formaPago", sortable: true },
    { name: `${t("Nota")}`, field: "nota", sortable: true },
    { name: `${t("Observaciones")}`, field: "observaciones", sortable: true },
    { name: `${t("Importe")}`, field: "importe", sortable: true },
    { name: `${t("Recibo")}`, field: "recibo", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.formaPago.toLowerCase().includes(search.toLowerCase()) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.nota.toLowerCase().includes(search.toLowerCase()) ||
          comment.importe.toString().includes(search) ||
          comment.numero.toString().includes(search) 
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (formaPago) {
      computedComments = computedComments.filter((e) =>
        e.formaPago.includes(formaPago)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "importe" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "importe" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "importe" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedFechaInicio,
    selectedFechaFin,
    formaPago
  ]);


    function EditAbono(
    _id,
    numero,
    fecha,
    idClientes,
    importe,
    observaciones,
    cliente,
    idNota,
  ) {
    setIdAbonoEdit(_id);
    setNumeroEdit(numero);
    setFechaEdit(fecha);
    setIdClienteEdit(idClientes);
    setImporteEdit(importe);
    setImporteEditViejo(importe);
    setObservacionesEdit(observaciones);
    setClienteEdit(cliente);
    setNotaEdit(idNota);
    toggleEdit();
  }

  const EditAbonoSave = (event) => {
    event.preventDefault();
    Swal.fire({
      title: "Estas seguro?",
      text: "Se registrará el abono",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ABONOS}/${idAbonoEdit}`,
            {
              importe: parseFloat(importeEdit) - parseFloat(importeEditViejo),
              clientes: idClienteEdit,
              ...((comments.find((c) => c._id === idAbonoEdit) || {}).esCargo ? { cargosContenedor: notaEdit } : { surtidos: notaEdit }),
              fecha: fechaEdit,
              observaciones: observacionesEdit,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Abono",
                detalle: `${clienteEdit}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  };

 
  let totalTabla = 0;
  return (
    <>
      <Header />
      {user.menuAbonos ? (
        <div className="card container col-sm-11">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <span className="page-title-icon"><i className="fas fa-hand-holding-usd" /></span>
                {t("Reporte de Abonos")}
              </h3>
              <p className="page-subtitle">{t("Pagos recibidos de clientes")}</p>
            </div>
            <div className="page-actions">
              {user.abonosCreate ? (
                <Button
                  size="sm"
                  type="submit"
                  color="success"
                  href="/AbonosCreate"
                >
                  <i className="fas fa-plus" /> {t("Nuevo Abono")}
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  color="success"
                  disabled
                >
                  <i className="fas fa-plus" /> {t("Nuevo Abono")}
                </Button>
              )}
              <Button
                size="sm"
                href="/Finanzas?tab=consultas"
                color="secondary"
                id="botonListado"
              >
                <i className="fas fa-arrow-left" /> {t("Regresar")}
              </Button>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  color="danger"
                  onClick={PDFTabla}
                >
                  <i className="far fa-file-pdf" /> PDF
                </Button>
                <Button
                  size="sm"
                  onClick={toggleMail}
                  color="info"
                >
                  <i className="fas fa-envelope" /> eMail
                </Button>
                <Button
                  size="sm"
                  color="primary"
                  onClick={excel}
                >
                  <i className="far fa-file-excel" /> Excel
                </Button>
              </ButtonGroup>
            </div>
          </div>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>{t("Enviar Listado Pagos")}</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="info" onClick={enviaMail}>
               <i className="fas fa-paper-plane" /> {t("Enviar")}
              </Button>
            </ModalFooter>
          </Modal>
          <div className="filter-bar">
            <div>
              <Label className="mr-sm-2">{t("Fecha Inicio")}</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </div>
            <div>
              <Label className="mr-sm-2">{t("Fecha Fin")}</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="stats-row">
            <div className="stat-chip"><i className="fas fa-receipt" style={{ color: "#2563eb" }} /> {t("Registros")} <span>{totalItems}</span></div>
            <div className="stat-chip"><i className="fas fa-dollar-sign" style={{ color: "#16a34a" }} /> {t("Importe")} <span>{"$" + new Intl.NumberFormat("en-US").format(commentsData.reduce((s, a) => s + a.importe, 0))}</span></div>
          </div>

          <div className="table-toolbar">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
            <Search
              onSearch={(value) => {
                setSearch(value);
                setCurrentPage(1);
              }}
            />
          </div>
          <Table size="sm" hover className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr className="filter-row">
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">{t("Selecciona")}</option>
                {clientes
                  .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
              </td>
             
            
              <td style={{ paddingTop: "0px" }}>
              <Input
                      type="select"
                      bsSize="sm"
                      value={formaPago}
                      onChange={(e) => {
                        setFormaPago(e.target.value);
                      }}
                    >
                      <option value="">{t("Selecciona una Forma de Pago")}</option>
                      <option value="Efectivo">{t("Efectivo")}</option>
                      <option value="Transfer">{t("Transfer")}</option>
                      <option value="TDC">TDC</option>
                    </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                      totalTabla = totalTabla + a.importe;
                {
                  return (
                    <tr>
                      <td className="td-strong">{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.formaPago}</td>
                      <td className="td-strong">{a.nota}</td>
                      <td>{a.observaciones}</td>
                      <td className="td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(a.importe)}</td>
                      <td>
                            <Button
                              size="sm"
                              color="danger"
                              title={t("Recibo")}
                              onClick={(e) =>
                                PDFOC(
                                  a.fecha,
                                  a.clientes,
                                  a.importe,
                                  a.nota,
                                  a.formaPago,
                                  a.observaciones,
                                  a.numero
                                )
                              }
                            >
                              <i className="far fa-file-pdf"></i>
                            </Button>
                             <Button
                                size="sm"
                                color="info"
                                title={t("Editar")}
                                onClick={(e) =>
                                  EditAbono(
                                    a._id,
                                    a.numero,
                                    a.fecha,
                                    a.idClientes,
                                    a.importe,
                                    a.observaciones,
                                    a.clientes,
                                    a.idNota,
                                  )
                                }
                              >
                                <i className="fas fa-edit"></i>
                              </Button>
                              <Button
                                size="sm"
                                color={a.comprobante === "Si" ? "success" : "secondary"}
                                title={a.comprobante === "Si" ? t("Ver comprobante de pago") : t("Subir comprobante de pago")}
                                onClick={() => setAbonoComprobante(a)}
                              >
                                <i className="fas fa-receipt"></i>
                              </Button>
                      </td>
                    
                    </tr>
                    
                  );
                }
              })}
                      <tr className="total-row">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="negrita" align="center">
                        TOTAL
                      </td>
                      <td className="negrita td-num td-money">
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, roundingIncrement: 5}).format(totalTabla)}
                      </td>
                      <td></td>
                    </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />
      <Modal size="lg" isOpen={!!abonoComprobante} toggle={() => setAbonoComprobante(null)}>
        <ModalHeader toggle={() => setAbonoComprobante(null)}>
          <span>{t("Comprobante de pago")} · {t("Abono")} {abonoComprobante ? abonoComprobante.numero : ""}</span>
        </ModalHeader>
        <ModalBody>
          {abonoComprobante ? (
            <DocumentosContenedor
              contenedorId={abonoComprobante._id}
              documentos={COMPROBANTE}
              docs={{ comprobanteAbono: abonoComprobante.comprobante }}
              puedeSubir={!!user.abonosCreate}
              onChange={(docs) => {
                const comprobante = docs.comprobanteAbono;
                setAbonoComprobante((x) => ({ ...x, comprobante }));
                setComments((cs) => cs.map((c) => (c._id === abonoComprobante._id ? { ...c, comprobante } : c)));
              }}
            />
          ) : null}
        </ModalBody>
      </Modal>

           <Modal size="sm" isOpen={modalEdit} toggle={toggleEdit}>
            <ModalHeader toggle={toggleEdit}>
              <h4>Editar Abono {numeroEdit} {clienteEdit}</h4>
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={EditAbonoSave}>
                <Row>
                  <Col md={6}>
                    <Label>Fecha</Label>
                    <Input
                      type="date"
                      value={fechaEdit}
                      required
                      onChange={(e) => {
                        setFechaEdit(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={6}>
                    <Label>Importe</Label>
                    <Input
                      className="col-sm-12"
                      type="number"
                      placeholder="Importe"
                      value={importeEdit}
                      required
                      onChange={(e) => {
                        setImporteEdit(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                <Col md={12}>
                    <Label>Observaciones</Label>
                    <Input
                      className="col-sm-12"
                      type="text"
                      placeholder="Observaciones"
                      value={observacionesEdit}
                      required
                      onChange={(e) => {
                        setObservacionesEdit(e.target.value);
                      }}
                    />
                  </Col>
                </Row>

                <br />
                <Row>
                    <Button type="submit" color="success">
                      <i className="fas fa-save" /> Guardar
                    </Button>

                  <div>
                    <SweetAlert
                      show={text}
                      title="Creado con Exito"
                      onConfirm={() => {
                        setText(false);
                      }}
                    />
                  </div>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
      {loader}
    </>
  );
}

export default ListadoAbonos;
